import { render, staticRenderFns } from "./ModalEstenderEtapa.vue?vue&type=template&id=0247081c&scoped=true"
import script from "./ModalEstenderEtapa.vue?vue&type=script&lang=js"
export * from "./ModalEstenderEtapa.vue?vue&type=script&lang=js"
import style0 from "./ModalEstenderEtapa.vue?vue&type=style&index=0&id=0247081c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0247081c",
  null
  
)

export default component.exports